<template>
  <div class="select-block">
    <h1>Seleccionar bloque</h1>

    <v-pagination
      v-model="blockNumber"
      :length="blockImages.length"
      ></v-pagination>

    <div class="block-image" :style="currentBlockImageStyle"
         @click="viewBlock(blockNumber - 1)"></div>

    <v-btn icon fixed bottom right @click="showInfo++">
      <v-icon>mdi-information</v-icon>
    </v-btn>
    <v-btn icon fixed bottom right class="btn-bill-of-materials" @click="showBillOfMaterials++">
      <v-icon>mdi-clipboard</v-icon>
    </v-btn>
    <design-info
      v-if="ready"
      v-model="showInfo"
    />
    <bill-of-materials
        v-if="ready"
        v-model="showBillOfMaterials"
      />
    <v-snackbar v-model="showErrorMessage">
      {{errorMessage}}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showError(false)"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import designService from '../services/design.service';
import BillOfMaterials from '../components/BillOfMaterials.vue';
import DesignInfo from '../components/DesignInfo.vue';

export default {
  name: 'select-block',
  components: {
    'bill-of-materials': BillOfMaterials,
    'design-info': DesignInfo,
  },
  data() {
    return {
      design: null,
      blockImages: [],
      ready: false,
      showBillOfMaterials: false,
      showInfo: true,
      errorMessage: null,
      showErrorMessage: false,
      blockNumber: -1,
    };
  },
  methods: {
    initialize() {
      if (this.design === designService.getCurrentDesign()) {
        this.ready = true;
        return;
      }
      this.ready = false;

      this.design = designService.getCurrentDesign();
      this.blockImages = designService.getBlockImages();

      this.showInfo = true;

      this.blockNumber = 1;
      this.ready = true;
    },
    showError(msg) {
      if (msg) {
        this.errorMessage = msg;
        this.showErrorMessage = true;
      } else {
        this.errorMessage = null;
        this.showErrorMessage = false;
      }
    },
    viewBlock(blockIdx) {
      this.$router.push({ name: 'view-block', params: { blockIdx }});
    },
  },
  computed: {
    currentBlockImageStyle() {
      return this.blockNumber < 1 ? {} : {
        backgroundImage: `url(${this.blockImages[this.blockNumber - 1].url})`,
      };
    },
  },
  activated() {
    this.initialize();
  }
};
</script>
<style>
.v-main {
  height: 100%;
}
.select-block {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.btn-bill-of-materials {
    margin-bottom: 2.5em;
}
.block-image {
  flex: 1;
  width: 90%;
  background-size: contain;
  background-position: center;
}
</style>
